import axios from "axios";
import * as actionType from "../../constant/actionType";
export const UpdateTaskArchiveStatus = (APIData) => async (dispatch) => {
  try {
    // dispatch(fetchData());
    const response = await axios({
      method: "patch",
      data: APIData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/worker/UpdateTaskArchiveStatus`,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
